import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  span {
    width: 160px;
    background: #c53030;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    opacity: 0;
    transition: opacity 0.4s;
    visibility: hidden;
    position: absolute;
    top: calc(100% + 12px);
    left: -250%;
    transform: translate(-50%);
    color: #312e38;
    z-index: 2000;

    &::before {
      content: '';
      border-style: solid;
      border-color: #c53030;
      border-width: 0px 6px 6px 6px;
      bottom: 100%;
      position: absolute;
      right: 2%;
    }
  }
  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;
